// extracted by mini-css-extract-plugin
module.exports =  {"appoint-menu":"AppointMenu-wZYS__appoint-menu","button":"AppointMenu-ZBMr__button"};